// Add Dropdown Menu Hover Functionality
// let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
// items.forEach(item => {
//   item.addEventListener("mouseover", () => {
//     item.setAttribute("open", true);
//     item.querySelector(".mega-menu__content").addEventListener("mouseleave", () => {
//       item.removeAttribute("open");
//     });
//     item.addEventListener("mouseleave", () => {
//       item.removeAttribute("open");
//     });
//   });  
// }); 

$(document).ready(function(){
  $('.announcement-slick').slick({
    infinite: true,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 8000,
    pauseOnHover: false,
    cssEase: 'linear',
    arrows: false,
    centerMode: true,
    variableWidth: true
    // slidesToShow: 1,
    // slidesToScroll: 1
  });
  
  $('.press-slick').slick({
    infinite: true,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 9000,
    pauseOnHover: false,
    cssEase: 'linear',
    arrows: false,
    variableWidth: true,
    mobileFirst: true, 
    responsive: [
       {
          breakpoint: 990,
          settings: "unslick"
       }
    ]
  });
  
  $('.drawer-menu-collection-slider').slick({
    infinite: true,
    autoplay: false,
    arrows: false,
    variableWidth: true,
    mobileFirst: true, 
    slidesToShow: 2,
    slidesToScroll: 1,
  });
  
});

$(window).resize(function () {
    $('.press-slick').not('.slick-initialized').slick('resize');
});

$(window).on('orientationchange', function () {
    $('.press-slick').not('.slick-initialized').slick('resize');
});

$(document).ready(function(event) {
  function fadeSection() {     
//     // $('.journal_page').addClass("fadeIn"); 
//     // $('.about_story').addClass("fadeIn"); 
//     // $('.terms_privacy').addClass("fadeIn"); 
//     // $('.product_section').addClass("fadeIn");
//     // $('.footer_common_sec').addClass("fadeIn");
//     // $('.faq').addClass("fadeIn");
//     // $('#shopify-section-template--15869645914291__form').addClass("fadeIn"); 
//     $('.section-header').find('section:first').addClass("fadeIn");
//     $('#MainContent').find('section:first').addClass("fadeIn");
       // $(".shopify-section").addClass("fadeIn"); 
  }
  
  setTimeout(fadeSection, 1000);
});

// $(window).scroll(function(event) {
//   $(".shopify-section").each(function(i, el) {
//     var el = $(el);
//     if(el.is(":visible")){
//       el.addClass("fadeIn"); 
//     } else {}
//   });
// });


/* Efficient Metrics */
window.themeObj = {
  init: function() {
    window.themeObj.templates.init();
  },
  templates: {
    init: function() {

      if ($('body.template-index').length) {
        window.themeObj.templates.index();
      
      } else if ($('body.template-collection').length) {
        window.themeObj.templates.collection();
      }
    },
    index: function() {
      const imageBannerGroup = $('section[data-component="image-banner-group"]');

      if (imageBannerGroup.length) {
        const imageBannerGroupId = imageBannerGroup.attr('data-image-banner-group-id');
        const imageBannerGroupItems = imageBannerGroup.find('.image-banner__items');
        
        const imageBannerItems = $('.shopify-section--ImageBanner .banner[data-image-banner-group-id="' + imageBannerGroupId + '"]');
        
        if (imageBannerItems.length) {

          imageBannerItems.each(function() {
            const imageBannerItem = $(this);
            imageBannerGroupItems.append(imageBannerItem);
          });
        
          const imageBannerGroupItemsAutoplay = imageBannerGroupItems.attr('data-autoplay');

          imageBannerGroupItems.not('.slick-initialized').slick({
            fade: true,
            speed: 750,
            cssEase: 'linear',
            autoplay: imageBannerGroupItemsAutoplay ? true : false,
            autoplaySpeed: imageBannerGroupItemsAutoplay ? imageBannerGroupItemsAutoplay : null,
            dots: true,
            infinite: true,
            arrows: false,
            slidesToShow: 1,
            pauseOnFocus: false, 
            pauseOnHover: false,
            prevArrow: '<div class="image-banner__arrow-left"><img src="' + imageBannerGroup.attr('data-slider-prev') + '" alt=""></div>',
            nextArrow: '<div class="image-banner__arrow-right"><img src="' + imageBannerGroup.attr('data-slider-next') + '" alt=""></div>'
          });
        }
      }
    },
    collection: function() {
      /* Collection CMS */
      const collectionCmsData = $('.collection-template-cms__data');
    
      if (collectionCmsData.length) {
        $.ajax({
          type: 'GET',
          url: collectionCmsData.attr('data-cms-query'),
          dataType: 'html',
          success: function (result) {
            const collectionContent = $('.shopify-section--MainCollectionCMS > div[data-section="main-collection-cms"]');
            const ajaxCollectionContent = $(result).find('.shopify-section--MainCollectionProductGrid > div[data-section="main-collection-product-grid"]');

            if (collectionContent.length && ajaxCollectionContent.length) {
              collectionContent.html(ajaxCollectionContent.html());

              const collectionFooter = $('.collection-footer');

              if (collectionFooter.length) {
                collectionFooter.removeClass('collection-footer--hidden');
              }
            }
          }
        });
        /* /Collection CMS */
      }
        
      $(document).on('change', '.mobile-facets__checkbox', function() {
        const checkbox = $(this);
    
        const filterLabel = checkbox.parents('.mobile-facets__details').find('.mobile-facets__summary-label');
        
        const filterLabelCount = filterLabel.find('.mobile-facets__summary-count > span');
    
        const filterLabelCountValue = parseInt(filterLabelCount.attr('data-count'));
        var newFlterLabelCountValue;
    
        if (checkbox.prop('checked')) {
          newFlterLabelCountValue = filterLabelCountValue + 1;
          
        } else {
          newFlterLabelCountValue = filterLabelCountValue - 1;
        }
    
        if (newFlterLabelCountValue < 0) {
          newFlterLabelCountValue = 0;
        }
    
        if (newFlterLabelCountValue > 0) {
          filterLabel.addClass('active');
        
        } else {
          filterLabel.removeClass('active');
        }
    
        filterLabelCount.attr('data-count', newFlterLabelCountValue);
      });
    }
  }
};

$(document).ready(function() {
  window.themeObj.init();
});
/* /Efficient Metrics */